import { render, staticRenderFns } from "./ConfigAdmin.vue?vue&type=template&id=cca809a2&"
import script from "./ConfigAdmin.vue?vue&type=script&lang=js&"
export * from "./ConfigAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ConfigAdmin.vue?vue&type=style&index=0&id=cca809a2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports